<template>
    <div class="activity-section" :class="is_admin ? {editable} : ''">
        <div class="head" @click="edit()">
            <h6 v-if="section.name">{{ section.name }}</h6>
            <div v-else-if="editable" class="text-muted">Heading for this section is not given.</div>
            <markdown-text :content="section.description"/>
            <div class="actions" @click.prevent.stop>
                <print-activities :stage="stage" :path="path" :section="section" />
            </div>
        </div>
        <draggable v-if="editable"
                   class="activities"
                   v-model="elements"
                   item-key="id"
                   @change="changed"
                   group="activity-section">
            <template #item="{element, index}">
                <div :class="elementWidthClass(element.element)"
                     class="item">

                    <div class="hover-actions">
                        <a href="#" class="remove" @click.prevent.stop="remove(element, index, true)"></a>
                    </div>

                    <activity v-if="element.element.type === 'activity'"
                              :activity="element.element"
                              :editable="true"
                              @remove-activity="remove(element, index)" />

                    <template v-if="element.element.type === 'resource'">

                        <podcast v-if="element.element?.data?.type === 'podcast'"
                                :path="path"
                                :stage="stage"
                                :section="section"
                                :editable="true"
                                :element="element"
                                :headless="true"
                                :hideSidebar="true"
                                @remove-resource="remove(element, index)"/>

                        <resource v-else
                                  :editable="false"
                                  :resource="element.element"
                                  @remove-resource="remove(element, index)"/>

                    </template>
                </div>
            </template>
        </draggable>
        <div v-else class="activities">
            <div v-for="(element, index) in elements" :class="elementWidthClass(element.element)" class="item">

                <activity v-if="element.element.type === 'activity'"
                          :activity="element.element"
                          :editable="false"
                          @remove-activity="remove(element, index)" />

                <template v-if="element.element.type === 'resource'">

                    <podcast v-if="element.element?.data?.type === 'podcast'"
                            :path="path"
                            :stage="stage"
                            :section="section"
                            :editable="true"
                            :element="element"
                            :headless="true"
                            :hideSidebar="true"
                            @remove-resource="remove(element, index)"/>

                    <resource v-else
                              :editable="false"
                              :resource="element.element"
                              @remove-resource="remove(element, index)"/>

                </template>
            </div>
        </div>

    </div>
</template>

<script>
import Activity from "@/Components/LearningPath/Activity";
import Resource from "@/Components/LearningPath/Resource";
import Modal from "@/Components/Common/Modal";
import MarkdownText from "@/Components/Common/MarkdownText";
import utils from "@/mixins/utils";
import API from "@/API";
import draggable from "vuedraggable";
import ActivitySection from "@/Components/LearningPath/ActivitySection";
import PrintActivities from "@/Components/LearningPath/PrintActivities";
import Podcast from "@/Components/LearningPath/Podcast";
import {mapActions} from "vuex";

export default {
    name: "CombinedActivitySection",
    components: {Podcast, PrintActivities, ActivitySection, Activity, Resource, Modal, MarkdownText, draggable },
    props: ['stage', 'path', 'section', 'number', 'editable'],
    emits: ['activities-changed', 'select-activity'],
    mixins: [utils],

    data(){
        return {
            is_ready: false,
            elements: [],
        }
    },

    computed: {
        fragment_key(){
            return `stage_${this.stage}_combined_activities_${this.section.id}`;
        },
        items(){
            return typeof this.path.fragments[ this.fragment_key ] !== 'undefined' ? this.path.fragments[ this.fragment_key ] : [];
        }
    },

    watch:{
        async items(){
            await this.fetch();
        }
    },

    methods:{
        ...mapActions('repositories', { repo: 'getRepository', updateRepo: 'updateRepository' }),

        elementWidthClass(element){
            try{ return `aw-${element.data.options.width}` } catch (e) {}
            return 'aw-1';
        },
        edit(){
            if( !this.editable || !this.is_admin ) return;
            this.$emit('edit-activity-section');
        },

        remove(item, index, requiresConfirmation = false){
            // Cannot check for editable as podcast can always be editable
            // TODO: Find aother way, so that the editable field doesn't control the podcast's update feature.
            // if( !this.editable ) return;

            const msg = 'Are you sure to remove this? Any associated data will also be removed.';
            if( requiresConfirmation && !confirm(msg) ) return;

            this.elements.splice(index, 1);
            const activities = this.items.filter((item, idx) => idx !== index);
            this.$emit('combined-activities-changed', {stage: this.stage, section: this.section, activities});
        },

        changed(changes){
            if( !this.editable ) return;
            if( typeof changes.moved !== 'undefined' || changes.added !== 'undefined' ){
                console.log("CHANGES:", changes.added)
                if (changes.added.element?.fromLearningPath) {
                    const fragments = {};
                    fragments[`stage_${this.stage}_${this.section.id}_podcast_${changes.added.element.id}`] = { podcast: { id: changes.added.element.podcast.id, short_name: changes.added.element.podcast.slug } };
                    this.updateRepo({scope: changes.added.element.scope, fragments});
                }
                this.$emit('combined-activities-changed', {
                    stage: this.stage,
                    section: this.section,
                    activities: this.elements.map(e => ({
                        id: e.id,
                        v: e.element.id,
                    })),
                    shouldReloadPage: changes.added.element?.fromLearningPath ? true : false
                });
            }
        },

        async fetch(){
            if( !this.items.length ) return;
            const elements = await API.elements.bulk({ids: this.items.map(item => item.v)});
            const filled_elements = [];
            for (let i = 0; i < this.items.length; i++){
                const item = this.items[i];
                const found = elements.filter(e => e.id === item.v);
                if( found.length ){
                    filled_elements[i] = {
                        id: item.id,
                        element: found.shift(),
                    };
                }
            }

            this.elements = filled_elements;
            console.log("ELEMENTS:", this.elements)
        }

    },

    beforeMount() {
        this.is_admin = this.$page.props.user.is_admin
    },

    async mounted(){

        await this.fetch();
        this.is_ready = true;

        this.emitter.on('path.add-element', (ev) => {

            // console.log('EVENT: path.add-element', {
            //     ev,
            //     stage: this.stage,
            //     stage_id: ev.stage_id,
            //     section_id: this.section.id,
            //     group_id: ev.group_id
            // });

            if( this.stage === ev.stage_id && this.section.id === ev.group_id ){
                console.log("ELEMENT:", ev.element)
                this.elements.push(ev.element);
                this.changed({added: [ev.element]});
            }
        });

    }
}
</script>

<style lang="scss" scoped>


.activity-section{
    .head{
        background-color: rgba(white, 0.1);
        backdrop-filter: blur(3px);
        padding: 1em 5.5rem 0.2em 1em;
        margin-bottom: 1em;
        border-radius: 0.3rem;
        position: relative;
    }

    .actions{
        position: absolute;
        right: 1rem;
        top: 50%;
        transform: translate(0, -50%);
    }

}

.activities{
    display: flex;
    margin-left: -0.3rem;
    margin-right: -0.3rem;
    flex-wrap: wrap;
    align-items: stretch;

    .item{
        display: flex;
        padding: 0 0.3rem;
        margin-bottom: 0.6rem;
        position: relative;

        &:hover{
            .hover-actions{
                opacity: 1;
            }
        }
    }
}

.aw-1{
    @include media-breakpoint-up(lg){
        flex: 0 0 20%;
    }
}

.aw-2{
    @include media-breakpoint-up(lg){
        flex: 0 0 40%;
    }
}

.aw-3{
    @include media-breakpoint-up(lg){
        flex: 0 0 60%;
    }
}
.aw-4{
    @include media-breakpoint-up(lg){
        flex: 0 0 80%;
    }
}
// .aw-5{

// }

.activity-section.editable{
    .head{
        min-height: 2rem;

        &:hover{
            cursor: text;
            background: rgba(black, 0.05);
        }
    }


    .activities{
        &:after{
            content: 'Drag activities/resources from the toolbox to the learning path';
            background: rgba($light-borders, 0.2);
            flex: 0 0 19%;
            margin-left: .5%;
            display: flex;
            align-items: center;
            justify-content: center;
            min-height: 200px;
            text-align: center;
            border-radius: 0.3rem;
            padding: 1.5rem;
            box-shadow: rgba(black, 0.1) 0 0 5px inset;
            margin-bottom: 0.7rem;
            margin-top: 0.1rem;
            font-style: italic;
            color: darken($light-borders, 25%);
        }
    }

}

.hover-actions{
    position: absolute;
    top: 1rem;
    right: 1rem;
    display: flex;
    z-index: 10;
    opacity: 0;

    a{
        display: flex;
        align-items: center;
        justify-content: center;
        width: 1.5rem;
        height: 1.5rem;
        border-radius: .3rem;
        text-decoration: none;

        &.remove{
            background: $danger;

            &:after{
                content: '×';
                color: white;
                line-height: 0;
                font-size: 1.2em;
            }
        }
    }
}

</style>
